// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"54ff05f2","281":"2eec97d3","324":"13e4ed73","453":"fc3a94dd"}[chunkId] + ".chunk.js";
};